module.exports = __webpack_public_path__ + "./Kimmy_pbw_a0d2a41104fec6689f1c9fa8100dbf67.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Kimmy_pbw.png
// module id = 597
// module chunks = 0